export const locale = {
    lang: 'es',
    data: {
        INVENTARIO: {
            ADD: {
                TITLE: 'NUEVO INVENTARIO'
            }
        }
    }
};
